import {gql} from 'graphql-request';
import {useGqlRequest} from '@/api/request';
import {useSession} from '@/hooks';
import {BasicAnalysisResult} from '@/map/@types';
import {buildAiPromptUserScript} from '@/utils';
import {useQuery} from '@tanstack/react-query';

export const useFetchAiPrompt = (id?: string, data?: BasicAnalysisResult) => {
  const {user} = useSession();
  const request = useGqlRequest({
    query: QUERY_AREA_ANALYZER_AI_CHAT,
  });

  const queryFn = ():
    | undefined
    | Promise<{
        result: string;
      }> => {
    if (!data) {
      return;
    }

    const content = buildAiPromptUserScript(data, user?.profile);

    return request({content});
  };

  return useQuery({
    queryFn,
    queryKey: ['map', 'analytics', id, 'ai-prompt'],
    enabled: !!id && !!data,
    staleTime: Infinity,
  });
};

const QUERY_AREA_ANALYZER_AI_CHAT = gql`
  query areaAnalyzerAiChat($content: String!) {
    result: areaAnalyzerAiChat(content: $content)
  }
`;
